import { render, staticRenderFns } from "./ImoFalForm1Grid.vue?vue&type=template&id=3585ef2d"
import script from "./ImoFalForm1Grid.vue?vue&type=script&lang=js"
export * from "./ImoFalForm1Grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports